/* cf-pill-popover-fix.js - Click Fencing, 2026-09-02
 *
 * Pete: "when i go to this section it has buttons at the bottom of the drop drown but if i
 *        move my mouse the options dissapear before i get to them"
 *
 * ---------------------------------------------------------------------------------------
 * IT WAS NOT A TIMING PROBLEM. The buttons could never be reached at all.
 *
 * The saved-quote pills on /pages/quote-review show a preview popover on hover. Its CSS,
 * read off the live page:
 *
 *     .qr-pill-preview            { pointer-events: none; opacity: 0; }
 *     .qr-pill-preview.is-visible { opacity: 1; }
 *
 * The visible state brings the opacity back but NEVER restores pointer-events. Measured on
 * the live popover with the buttons present: the popover computes pointer-events "none", and
 * so does every button inside it. It was built as a look-only preview tooltip, and later work
 * put "Review quote" and "Edit sections" buttons inside it - controls sitting in a container
 * that the mouse cannot touch. No amount of moving the pointer faster would ever have worked.
 *
 * There is a second, smaller problem stacked on top, in quote-review.js:
 *
 *     function hidePreview(){ _previewTimeout = setTimeout(
 *       () => { _previewEl.classList.remove("is-visible") }, 120) }
 *     btn.addEventListener("mouseleave", hidePreview)
 *
 * The popover hides 120ms after the pointer leaves the PILL, and nothing cancels that timer,
 * because the popover cannot receive a mouseenter to cancel it with. So even once it is
 * clickable it would still vanish underneath the pointer.
 *
 * ---------------------------------------------------------------------------------------
 * THE FIX, both halves.
 *
 * 1. Restore pointer-events on the visible popover, so the buttons inside it are real.
 * 2. Keep it open while the pointer is actually over it. We cannot clear their private
 *    _previewTimeout, so instead we re-assert is-visible for as long as the pointer is
 *    inside - a MutationObserver puts the class straight back if their timer strips it.
 *    Leaving the popover hides it, which is what a customer expects.
 *
 * The pill sits 4px above the popover with 118px of horizontal overlap (measured), so the
 * pointer crosses into it well inside the 120ms grace and the keep-open then takes over.
 *
 * MOBILE IS NOT LEFT STRANDED. Hover does not exist on touch, so these two buttons stay
 * desktop-only - but neither action is trapped in here: tapping the pill itself opens the
 * quote, and "Edit sections" is also added to the main action row next to Clear by
 * cf-quote-edit.js. Nothing is only reachable through this popover.
 *
 * Display and behaviour only - no quote, price, product or cart line is touched.
 */
(function () {
  'use strict';

  if (window.__cfPillPopoverFix) return;
  window.__cfPillPopoverFix = true;

  var POP_ID = 'qr-pill-preview-popover';
  var STYLE_ID = 'cf-pill-popover-css';

  function css() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    /* Only the VISIBLE popover becomes interactive. While hidden it stays pointer-events:none
       so it can never sit invisibly on top of the page and swallow clicks. */
    s.textContent =
      '.qr-pill-preview.is-visible{pointer-events:auto;}' +
      '.qr-pill-preview [data-cf-pop-actions]{pointer-events:auto;}' +
      '.qr-pill-preview [data-cf-pop-actions] button{cursor:pointer;}' +
      '.qr-pill-preview [data-cf-pop-actions] button:hover{background:#f1f5f9;}';
    (document.head || document.documentElement).appendChild(s);
  }

  var bound = null;

  function bind() {
    var pop = document.getElementById(POP_ID);
    if (!pop || pop === bound) return;
    bound = pop;

    var over = false;

    pop.addEventListener('mouseenter', function () {
      over = true;
      pop.classList.add('is-visible');
    });

    pop.addEventListener('mouseleave', function () {
      over = false;
      pop.classList.remove('is-visible');
    });

    /* Their 120ms timer will strip is-visible while the pointer is still inside. Put it back.
       Only ever while genuinely hovered, so this can never pin the popover open. */
    try {
      new MutationObserver(function () {
        if (over && !pop.classList.contains('is-visible')) pop.classList.add('is-visible');
      }).observe(pop, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }

  function start() {
    css();
    bind();
    /* The popover is built with the pill list, and the list is rebuilt when quotes change,
       so keep looking for a fresh node for a while rather than binding once and hoping. */
    var n = 0;
    (function tick() {
      if (n++ > 60) return;
      bind();
      setTimeout(tick, 500);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  try { console.log('[cf-pill-popover-fix] installed'); } catch (e) {}
})();
